import styled from "styled-components";

function JobName() {
    const className = {
  0: "Aprendiz",
  1: "Espadachim",
  2: "Mago",
  3: "Arqueiro",
  4: "Noviço",
  5: "Mercador",
  6: "Gatuno",

  // === Classes 2 (Não-Trans) ===
  7: "Cavaleiro",
  8: "Sacerdote",
  9: "Bruxo",
  10: "Ferreiro",
  11: "Caçador",
  12: "Mercenário",
  14: "Templário", // Crusader
  15: "Monge",
  16: "Sábio",
  17: "Arruaceiro",
  18: "Alquimista",
  19: "Bardo",
  20: "Odalisca",

  // === Classes Transcendentais (2-1 T e 2-2 T) ===
  // Note que os IDs das Transclasses são mais altos do que as classes 2 normais
  // e levam às 3ªs classes.
  4001: "Noviço T.",
  4002: "Espadachim T.", // High Novice
  4003: "Mago T.", // High Mage
  4004: "Arqueiro T.", // High Archer
  4005: "Noviço T.", // High Merchant
  4006: "Mercador T.", // High Thief
  4007: "Gatuno T.", // High Acolyte

  4008: "Lorde", // Lord Knight (Cavaleiro T.)
  4009: "Sumo Sacerdote", // High Priest (Sacerdote T.)
  4010: "Arquimago", // High Wizard (Bruxo T.)
  4011: "Mestre-Ferreiro", // Sniper (Caçador T.)
  4012: "Atirador-de-Elite", // Whitesmith (Ferreiro T.)
  4013: "Algoz", // Assassin Cross (Mercenário T.)
  4015: "Cavaleiro Templário", // Paladin (Templário T.)
  4016: "Mestre", // Champion (Monge T.)
  4017: "Professor", // Scholar (Sábio T.)
  4018: "Desordeiro", // Stalker (Desordeiro T.)
  4019: "Criador", // Creator (Alquimista T.)
  4020: "Menestrel", // Clown (Bardo T.)
  4021: "Cigana", // Gypsy (Odalisca T.)


  // === Terceiras Classes (3rd Jobs) ===
  4054: "Cavaleiro Rúnico",
  4055: "Arcano",
  4056: "Sentinela",
  4057: "Arce Bispo",
  4058: "Mecanico",
  4059: "Sicário",
  4066: "Guardião Real",
  4067: "Feiticeiro",
  4068: "Trovador",
  4069: "Musa",
  4070: "Shura",
  4071: "Bioquímico",
  4072: "Renegado",

  // === Terceiras TransClasses (3rd Jobs) ===
  4060: "Cavaleiro Rúnico",
  4061: "Arcano",
  4062: "Sentinela",
  4063: "Arce Bispo",
  4064: "Mecanico",
  4065: "Sicário",
  4073: "Guardião Real",
  4074: "Feiticeiro",
  4075: "Trovador",
  4076: "Musa",
  4077: "Shura",
  4078: "Bioquímico",
  4079: "Renegado",



  // === Quartas Classes (4th/5th Jobs - Pós-Renewal) ===

  4252: "Cavaleiro Dragão",
  4253: "Meister",
  4254: "Shadow Cross",
  4255: "Mago Supremo",
  4256: "Cardeal",
  4257: "Windhawk",
  4258: "Guarda Imperial",
  4259: "Biolo",
  4260: "Abyss Chaser",
  4261: "Elemental Master",
  4262: "Inquisitor",
  4263: "Troubadour",
  4264: "Trouvere",


  // === Classes Expandidas (Não-Trans/Revolução) ===
  23: "Super-Aprendiz", // CORRIGIDO: Ninja é ID 25, não 4027
  24: "Justiceiro", // Gunslinger é ID 26
  25: "Ninja",
  4045: "Super Bebê",
  4046: "Taekwon",
  4047: "Mestre Taekwon",
  4049: "Espiritualista",
  4190: "Super-Aprendiz EX",
  4191: "Super-Bebê EX",
  4211: "Kagerou",
  4212: "Oboro",
  4215: "Rebelion",
  4239: "Imperador Estelar",
  4240: "Ceifador de Almas",
  4302: "Sky Emperor",
  4303: "Soul Ascetic",
  4304: "Shinkiro",
  4305: "Shiranui",
  4306: "Nighwatch",
  4307: "Hyper-Aprendiz",
  4308: "Spirit Handler",
  4218: "Invocador", // (Doram)

  //Baby 1st Class

  4023: "Aprendiz",
  4024: "Espadachim",
  4025: "Mago",
  4026: "Arqueiro",
  4027: "Noviço",
  4028: "Mercador",
  4029: "Gatuno",

   // === Baby Classes 2 (Não-Trans) ===
  4030: "Cavaleiro",
  4031: "Sacerdote",
  4032: "Bruxo",
  4033: "Ferreiro",
  4034: "Caçador",
  4035: "Mercenário",
  4037: "Templário", // Crusader
  4038: "Monge",
  4039: "Sábio",
  4040: "Arruaceiro",
  4041: "Alquimista",
  4042: "Bardo",
  4043: "Odalisca",


  // === Baby Terceiras TransClasses (3rd Jobs) ===
  4096: "Cavaleiro Rúnico",
  4097: "Arcano",
  4098: "Sentinela",
  4099: "Arce Bispo",
  4100: "Mecanico",
  4101: "Sicário",
  4102: "Guardião Real",
  4103: "Feiticeiro",
  4104: "Trovador",
  4105: "Musa",
  4106: "Shura",
  4107: "Bioquímico",
  4108: "Renegado",


  // === Baby Classes Expandidas (Não-Trans/Revolução) ===
  4220: "Invocador", // (Doram)
  4222: "Ninja",
  4223: "Kagerou", // (3ª Classe Ninja M)
  4224: "Oboro", // (3ª Classe Ninja F)
  4425: "Taekwon",
  4426: "Mestre Taekwon",
  4227: "Espiritualista",
  4228: "Justiceiro", // Gunslinger é ID 26
  4229: "Rebelde", // (3ª Classe Justiceiro)
  4241: "Imperador Estelar",
  4242: "Ceifador de Almas"

}
    return(className);
}

export default JobName;